import { RouteConfig } from "vue-router";

export const RCompanyDataHistory: RouteConfig = {
  path: "data-history",
  name: "companiesCompanyDataHistory",
  component: () =>
    import(
      /* webpackChunkName: "companies-template-company-data-history" */
      "./VCompanyDataHistory.vue"
    ),
  meta: {
    label: "data-history",
    title: "Companies",
  },
};
